// extracted by mini-css-extract-plugin
module.exports = {"genre":"ob_de0nrb","genreTagsExpanded":"ob_C0SvEd","tagsList":"ob_ThdKKv","tag":"ob_PdLEiV","genreTags":"ob_FxMmon","genre__tag":"ob_AdpZKa"};